/**
 * Class description
 *
 * Created: 2017-10-12
 * @author jonas
 */
import {DungeonQuestGameConfig} from "../DungeonQuestGameConfig";
import {IResizeData} from "@nolimitcity/slot-game/bin/core/stage/StageManager";


export class DungeonQuestShockWaveController {
    private _reelRect:PIXI.Rectangle;

    constructor() {

    }


    public onResize(resizeData:IResizeData):void {
        this._reelRect = new PIXI.Rectangle(
            DungeonQuestGameConfig.instance.REEL_AREA_POS_X,
            DungeonQuestGameConfig.instance.REEL_AREA_POS_Y,
            DungeonQuestGameConfig.instance.SYMBOL_WIDTH,
            DungeonQuestGameConfig.instance.SYMBOL_HEIGHT
        );
    }


    /*
        private createCircleShockWaveStateMatrix(data:ColossalSymbolInfo):StateMatrix<number> {
            const centerIndex = new PIXI.Point(data.position[0] + (data.size - 1) * 0.5, data.position[1] + (data.size - 1) * 0.5);
            const waveDistanceMatrix = new StateMatrix<number>(5, 7, [0, 6]);
            waveDistanceMatrix.populate(0);
            for(let reelIndex:number = 0; reelIndex < 5; reelIndex++) {
                for(let symbolIndex:number = 0; symbolIndex < 7; symbolIndex++) {
                    let distance:number = Math.abs(reelIndex - centerIndex.x);
                    distance += Math.abs(symbolIndex - centerIndex.y);
                    distance = Math.floor(distance);
                    waveDistanceMatrix.setStateAt(reelIndex, symbolIndex, distance);
                }
            }
            return waveDistanceMatrix;
        }
    */


    /*

        private createPointShockWaveMatrix(data:ColossalSymbolInfo):StateMatrix<number> {
            let waveDistanceMatrix = new StateMatrix<number>(5, 7, [0, 6],0);

            for(let reelIndex:number = data.position[0]; reelIndex < data.position[0] + data.size; reelIndex++) {
                for(let symbolIndex:number = data.position[1]; symbolIndex < data.position[1] + data.size; symbolIndex++) {
                    waveDistanceMatrix = this.pointShockWave(reelIndex,symbolIndex,waveDistanceMatrix);
                }
            }
            for(let reelIndex:number = data.position[0]; reelIndex < data.position[0] + data.size; reelIndex++) {
                for(let symbolIndex:number = data.position[1]; symbolIndex < data.position[1] + data.size; symbolIndex++) {
                    waveDistanceMatrix.setStateAt(reelIndex,symbolIndex,0);
                }
            }

            return waveDistanceMatrix;
        }
    */
    /*

        private pointShockWave(x:number, y:number, waveDistanceMatrix:StateMatrix<number>):StateMatrix<number> {
            for(let reelIndex:number = 0; reelIndex < 5; reelIndex++) {
                for(let symbolIndex:number = 0; symbolIndex < 7; symbolIndex++) {
                    let distance:number = Math.abs(reelIndex - x);
                    distance += Math.abs(symbolIndex - y);
                    distance += waveDistanceMatrix.getStateAt(reelIndex,symbolIndex);
                    waveDistanceMatrix.setStateAt(reelIndex, symbolIndex, distance);
                }
            }
            return waveDistanceMatrix;
        }
    */


}